import React, { memo, forwardRef } from "react";
const SvgProportional = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M25.921 12c-1.015 0-1.989.403-2.707 1.121L20.336 16l2.878 2.879A3.829 3.829 0 0025.921 20v2a5.829 5.829 0 01-4.12-1.707l-2.88-2.879-2.503 2.503c-2.42 2.421-6.436 2.089-8.425-.697a5.54 5.54 0 010-6.44c1.99-2.786 6.005-3.118 8.425-.697l2.503 2.503 2.88-2.879A5.829 5.829 0 0125.92 10v2zm-8.414 4l-2.503-2.503a3.54 3.54 0 100 5.006L17.507 16z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgProportional.displayName = "SvgProportional";
const MemoForwardRef = memo(SvgProportional);
export default MemoForwardRef;
